import React from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { SectionHeader } from "../components/section-header";
import { SectionLoader } from "../components/section-loader";
import { EmptyState } from "@/components/shared/empty-state";
import { Calendar, ArrowRight } from "lucide-react";

interface UpcomingEventsSectionProps {
  items: any[];
  isLoading: boolean;
}

export function UpcomingEventsSection({ items, isLoading }: UpcomingEventsSectionProps) {
  const displayItems = items.length > 0 ? items.slice(0, 3) : [];

  if (!displayItems.length && !isLoading) return null;

  return (
    <section className="border-b border-border bg-neutral-50/50" aria-labelledby="events-heading">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <SectionHeader
          eyebrow="Events"
          icon={Calendar}
          title="Upcoming Events"
          href="/events"
        />
        {isLoading ? (
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-20 bg-neutral-100 rounded-xl animate-pulse" />
            ))}
          </div>
        ) : displayItems.length > 0 ? (
          <div className="space-y-3">
            {displayItems.map((item: any) => (
              <Link key={item.id} href={`/events/${item.id}`}>
                <Card className="group hover:border-neutral-300 transition-all duration-150">
                  <CardContent className="p-4">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-heading font-semibold text-foreground group-hover:text-primary transition-colors line-clamp-1">
                          {item.title}
                        </h4>
                        <p className="text-xs text-muted-foreground mt-1">{item.location}</p>
                        <p className="text-xs text-muted-foreground mt-0.5">{item.date}</p>
                      </div>
                      <Button variant="ghost" size="xs" className="shrink-0 mt-1">
                        Register
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        ) : (
          <EmptyState icon={Calendar} description="No upcoming events." />
        )}
      </div>
    </section>
  );
}